import { render } from "./cp_school.vue?vue&type=template&id=9378fbea&scoped=true"
import script from "./cp_school.vue?vue&type=script&lang=js"
export * from "./cp_school.vue?vue&type=script&lang=js"

import "./cp_school.vue?vue&type=style&index=0&id=9378fbea&scoped=scoped&lang=css"

import exportComponent from "D:\\Work\\高报云\\代码和文档\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9378fbea"]])

export default __exports__